import React, { useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
// import Navbar from "../Navbar";
import async from "../../utils/service";
import "../../style/userList.css";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Tooltip } from "primereact/tooltip";
import { Checkbox } from "primereact/checkbox";
import { InputTextarea } from "primereact/inputtextarea";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import useGetRegions from "../../hooks/useRegions";
import useGetChannels from "../../hooks/useChannels";
import useGetUserStatuses from "./hooks/useGetUserStatuses";
import { USER_STATUS, ACTIVATION_CODE, DEACTIVATION_CODE } from "../../utils/common";
import AgSelectFilter from "../common/AgSelectFilter";
import moment from "moment";
import { capitalCase } from "text-capital-case";

let defaultRejectReason =
  "Thank you for your interest in MiApp. Unfortunately we could not approve your access as your request requires that your company is confirmed as an active customer with Cargill, that you provide your Cargill Account Manager name, and that you provide a current business email address (private email addresses are not accepted).  Please resubmit your request with the required information or you may contact your account manager or MiApp@cargill.com if you need further assistance. Thank you.";
const getChannelName = (details, channels) => {
  if (details !== null && Array.isArray(channels)) {
    let channel = channels.find((channel) => channel.channelId === details.channelId);
    return channel ? channel.channelName : "";
  }
  return "";
};
const getRegions = (details, regions) => {
  if (details !== null && details !== undefined && Array.isArray(details) && Array.isArray(regions)) {
    return details.map((region) => regions.find((reg) => reg.id === region.regionId)?.region).filter((val) => !!val);
  }
  return [];
};
const ActionCell = (props) => {
  const isDeActivate = [
    USER_STATUS.ACTIVE.toLowerCase(),
    USER_STATUS.APPROVED.toLowerCase(),
    USER_STATUS.PROVISIONED.toLowerCase(),
    USER_STATUS.DEACTIVATION_PENDING.toLowerCase(),
  ].includes(props.data.status.toLowerCase());
  const isReActivate = [
    USER_STATUS.DENIED.toLowerCase(),
    USER_STATUS.REMOVED.toLowerCase(),
    USER_STATUS.REACTIVATION_PENDING.toLowerCase(),
  ].includes(props.data.status.toLowerCase());
  let ActionButton = null;
  if (isDeActivate) {
    ActionButton = (
      <Button
        style={{ borderRadius: "5px" }}
        type='button'
        label='Deactivate'
        className='btn3 m-0 p-0 userActionBtn'
        onClick={() => {
          props.setDeActivateDialog(true);
          props.setUserDeactivateData(props.data);
        }}
      ></Button>
    );
  }
  if (isReActivate) {
    ActionButton = (
      <Button
        style={{ borderRadius: "5px" }}
        type='button'
        label='Reactivate'
        className='btn3 m-0 p-0 userActionBtn'
        onClick={() => {
          props.setReActivateDialog(true);
          props.setUserDeactivateData(props.data);
        }}
      ></Button>
    );
  }
  return ActionButton;
};
const DropdownCell = (props) => {
  const handlechange = (event) => {
    var id = props.data.userId;
    var email = props.data.email.toLowerCase();
    props.setData((prevState, props) => ({ ...prevState, userId: id }));
    props.setData((prevState, props) => ({ ...prevState, email: email }));
    const isInternalUser = email.indexOf("cargill.com") !== -1 || email.indexOf("crgl-thirdparty.com") !== -1;
    props.setRedirectUrl(isInternalUser ? props.data.approvalUrl : "");

    var regs = "";
    var chanData = { ...props.data?.userChannelDetails };
    var RegData = props.data?.userChannelDetails?.userChannelRegionDetails.map((item, index) => {
      item["rejectReason"] = null;
      regs += item.region;
      regs += ",";
      return item;
    });
    regs = regs.substring(0, regs.length - 1);
    chanData.regions = regs;
    chanData.userChannelRegionDetails = RegData;

    if (event.target.value === "Approve") {
      props.setData((prevState) => ({
        ...prevState,
        isUserApproved: true,
        isUserChannelApproved: true,
        userChannelDetails: chanData,
      }));
      if (props.data.userChannelDetails !== null) {
        // var chanId = props.data.userChannelDetails.channelId
        // var RegIds = props.data.userChannelDetails.userChannelRegionDetails.map(item => ({regionRequestId : item.regionRequestId}))
        // props.setData((prevState, props) => ({...prevState, channelId : chanId}))
        // props.setData((prevState, props) => ({...prevState, userRejectRegions : RegIds}))

        props.setChecks(props.data.userChannelDetails.userChannelRegionDetails.map((item) => true));
        let channel = getChannelName(props.data.userChannelDetails, props.context.chanels);
        props.setChannel(channel);
        let regions = getRegions(props.data.userChannelDetails?.userChannelRegionDetails, props.context.regions);
        props.setRegions(regions);
        // props.setReasons(props.data.userChannelDetails.userChannelRegionDetails.map(item => ""))
      } else {
        props.setChannel("");
        props.setRegions("");
      }

      props.ToggleApprove(true);
    } else {
      chanData.channelRejectReason = defaultRejectReason;
      props.setData((prevState) => ({
        ...prevState,
        isUserChannelApproved: false,
        isUserApproved: false,
        userRejectReason: defaultRejectReason,
        userChannelDetails: chanData,
      }));
      props.ToggleDeny(true);
    }
    event.target.value = "select";
  };
  const { userStatusesWithDescription } = props.context;
  return (
    <>
      <Tooltip target='.custom-tooltip-btn' />
      {![USER_STATUS.DENIED.toLowerCase(), USER_STATUS.NEW.toLowerCase()].includes(props.data.status.toLowerCase()) && (
        <span
          style={{ color: "#638C1C" }}
          className='custom-tooltip-btn'
          data-pr-tooltip={userStatusesWithDescription[props.data.status.toLowerCase()] ?? "NA"}
        >
          {capitalCase(props.data.status)}
          <sup>*</sup>
        </span>
      )}
      {props.data.status.toLowerCase() === USER_STATUS.DENIED.toLowerCase() && (
        <span
          style={{ color: "#A22B2F" }}
          className='custom-tooltip-btn'
          data-pr-tooltip={userStatusesWithDescription[props.data.status.toLowerCase()] ?? "NA"}
        >
          {capitalCase(props.data.status)}
          <sup>*</sup>
        </span>
      )}
      {props.data.status.toLowerCase() === USER_STATUS.NEW.toLowerCase() && (
        <select defaultValue='select' onChange={(event) => handlechange(event)}>
          <option disabled value='select'>
            select
          </option>
          <option value='Approve'>Approve</option>
          <option value='Deny'>Reject</option>
        </select>
      )}
    </>
  );
};

function UserListDialogBody(props) {
  const handlechange = (text) => {
    // const temp = props.reasons.slice()
    const chanData = props.data.userChannelDetails;
    chanData.userChannelRegionDetails[props.ind]["rejectReason"] = text;
    props.updatedata({ ...props.data, userChannelDetails: chanData });
    // temp[props.ind] = text
    // props.setReasons(temp)
  };

  const handleCheckChange = (value) => {
    const temp = props.checks.slice();
    temp[props.ind] = value;
    const chanData = props.data.userChannelDetails;
    chanData.userChannelRegionDetails[props.ind]["rejectReason"] = value ? null : defaultRejectReason;
    props.updatedata({ ...props.data, userChannelDetails: chanData });
    props.setChecks(temp);
  };
  return (
    <div>
      <div className='field-checkbox sm:col-12 mb-0'>
        <Checkbox onChange={(e) => handleCheckChange(e.checked)} checked={props.checks[props.ind]} />
        <label>
          <div className='grid ml-2'>
            <div className='col-fixed p-0 p-text-left diag-header' style={{ width: "100px" }}>
              Channel
            </div>
            <div className='col-fixed p-0 text-center diag-header' style={{ width: "100px" }}>
              Region
            </div>
          </div>
          <div className='grid ml-2 mt-0'>
            <div className='col-fixed pl-0 p-text-left diag-row' style={{ width: "100px" }}>
              {props.channel}
            </div>
            <div className='col-fixed pl-0 text-center diag-row' style={{ width: "100px" }}>
              {props.region}
            </div>
          </div>
        </label>
      </div>
      {!props.checks[props.ind] ? (
        <div className='col-12'>
          <div className='text-center diag-reason'>Reason for Rejection</div>
          <div className='col-12'>
            <InputTextarea
              required
              rows={3}
              cols={30}
              value={
                props.data?.userChannelDetails?.userChannelRegionDetails[props.ind].rejectReason === null
                  ? ""
                  : props.data?.userChannelDetails?.userChannelRegionDetails[props.ind].rejectReason
              }
              onChange={(event) => handlechange(event.target.value)}
              keyfilter={/[a-zA-Z,@\s().]/}
            />
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
}

const channelGetter = (params) => {
  const { chanels } = params.context;
  const { userChannelDetails } = params.data;
  return getChannelName(userChannelDetails, chanels);
};

// const RegionsGetter = (params) => {
//   const { regions } = params.context;
//   const { userChannelDetails } = params.data;
//   return getRegions(userChannelDetails?.userChannelRegionDetails, regions).join(",");
// };
function UserList() {
  const [ShowApprovedDialog, setApprovedDialog] = React.useState(false);
  const [showDenyDialog, setDenyDialog] = React.useState(false);
  const [showDeActiveDialog, setDeActivateDialog] = React.useState(false);
  const [showReActiveDialog, setReActivateDialog] = React.useState(false);
  const [userDeActiveData, setUserDeactivateData] = React.useState(null);
  const [deactivateLoader, setDeactivateLoader] = React.useState(false);
  const toast = React.useRef(null);
  const dialogRef = React.useRef(null);
  const initSendData = {
    userId: 0,
    email: "",
    userRejectReason: "",
    isUserChannelApproved: true,
    isUserApproved: false,
    userChannelDetails: {
      channelId: 0,
      channel: "",
      regions: "",
      channelRejectReason: null,
      userChannelRegionDetails: [],
    },
  };
  const regionData = useGetRegions();
  const channelData = useGetChannels();
  const userStatuses = useGetUserStatuses();

  const [sendData, setSendData] = React.useState(initSendData);

  const [checks, setChecks] = React.useState([]);
  // const [channelCheck, setChannelCheck] = React.useState(false)
  // const [channelRejectReason, setChannelRejectReason] = React.useState("")
  const [channel, setChannel] = React.useState("");
  const [regions, setRegions] = React.useState([]);
  // const [reasons, setReasons] = React.useState([])
  const [redirecturl, setRedirectUrl] = React.useState("");
  const [buttonClick, setButtonClick] = React.useState(false);
  const [rowData, setRowData] = React.useState(null);
  const [gridApi, setGridApi] = React.useState(null);
  // eslint-disable-next-line
  const [gridColumnApi, setGridColumnApi] = React.useState(null);
  // const [rowHeight, setRowHeight] = React.useState(0);
  // const [headerHeight, setHeaderHeight] = React.useState(0);

  // function userAuthentication() {
  //   // async.AuthenticateUser(sendData).then(response => {
  //   //   setSendData(initSendData)
  //   // })
  // }
  const userAuthentication = (isApprove) => {
    gridApi.showLoadingOverlay();
    setButtonClick(false);
    delete sendData["email"];
    delete sendData.userChannelDetails["regions"];
    sendData.userChannelDetails.regionIds = sendData.userChannelDetails.userChannelRegionDetails.map(
      (regDetail) => regDetail.regionId
    );

    async
      .AuthenticateUser({ ...sendData, isReactivated: false })
      .then((response) => {
        if (isApprove && redirecturl.trim().length > 0) window.open(redirecturl);
        let msg = isApprove ? "The user is approved successfully" : "The user is rejected successfully";
        setSendData(initSendData);
        setButtonClick(true);

        toast.current.show({
          severity: "success",
          summary: "Success Message",
          detail: msg,
          life: 2000,
        });
      })
      .finally(() => {
        gridApi.hideOverlay();
      });
  };
  function handleReasonChange(event) {
    const chanData = sendData.userChannelDetails;
    chanData.channelRejectReason = event.target.value;
    setSendData({ ...sendData, userChannelDetails: chanData });
  }

  function handleAcceptSubmit() {
    setApprovedDialog(false);
    delete sendData["userRejectReason"];
    // var regs = ""
    // var RegData = sendData.userChannelDetails.userChannelRegionDetails.map((item, index) => {
    //   if (checks[index] === false){
    //     item["rejectReason"] = reasons[index]
    //   }
    //   else {
    //     item["rejectReason"] = null
    //   }
    //   regs += item.region
    //   regs += ','
    //   return item
    // })
    // regs = regs.substring(0, regs.length-1)
    // var chanData = sendData.userChannelDetails
    // chanData.regions = regs
    // chanData.userChannelRegionDetails = RegData

    // if (channelCheck) {
    //   chanData.channelRejectReason = channelRejectReason
    //   setSendData((prevState) => ({...prevState, isUserChannelApproved : false}))
    // }
    // else {

    //   if (checks.length > 0 && checks.reduce((sum, curvalue) => (sum && curvalue)) === true){
    //     setSendData((prevState) => ({...prevState, isUserChannelApproved : true}))
    //     // delete sendData["userRejectRegions"]
    //   }
    //   else {
    //     setSendData((prevState) => ({...prevState, isUserChannelApproved : true}))
    //   }
    // }
    // setSendData((prevState) => ({...prevState, userChannelDetails : chanData}))

    userAuthentication(1);
    // setButtonClick(true)
    // window.open(redirecturl)
  }

  const handleRejectSubmit = () => {
    setDenyDialog(false);

    // delete sendData["channelRejectReason"]
    // delete sendData["userRejectRegions"]
    delete sendData["channelId"];
    // delete sendData["isUserChannelApproved"]
    // setSendData((prevState) => ({...prevState, isUserChannelApproved : false}))
    // var regs = ""
    // var chanData = sendData.userChannelDetails

    // sendData.userChannelDetails.userChannelRegionDetails.map((item, index) => {
    //   regs += item.region
    //   regs += ','
    //   return item
    // })

    // for (var item in chanData.userChannelRegionDetails){
    //   regs += chanData.userChannelRegionDetails[item].region
    //   regs += ','
    // }
    // regs = regs.substring(0, regs.length-1)

    // chanData.regions = regs
    // chanData.channelRejectReason = channelRejectReason
    // setSendData((prevState) => ({...prevState, userChannelDetails : chanData}))

    userAuthentication(0);
    // setButtonClick(true)
  };

  const handleChange = (eve) => {
    var val = eve.target.value;
    setSendData((prevState) => ({ ...prevState, userRejectReason: val }));
  };

  const components = {
    actionsCell: ActionCell,
    dropdownCell: DropdownCell,
  };
  const gridOptions = {
    defaultColDef: {
      resizable: true,
      headerComponentParams: {
        template:
          '<div class="ag-cell-label-container" role="presentation">' +
          '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
          '  <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
          '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
          '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
          '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
          '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
          '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
          '    <span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
          "  </div>" +
          "</div>",
      },
      filterParams: { buttons: ["reset"] },
    },
    columnDefs: [
      {
        headerName: "Status",
        field: "status",
        cellRenderer: "dropdownCell",
        sortable: "true",
        filter: AgSelectFilter,
        cellRendererParams: {
          ToggleApprove: setApprovedDialog,
          ToggleDeny: setDenyDialog,
          setChannel: setChannel,
          setRegions: setRegions,
          // setReasons: setReasons,
          setChecks: setChecks,
          setData: setSendData,
          setRedirectUrl: setRedirectUrl,
        },
      },
      {
        headerName: "First Name",
        field: "firstName",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Last Name",
        field: "lastName",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Email",
        field: "email",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Company Name",
        field: "companyName",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Region",
        field: "userRegion",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Country",
        field: "country",
        filter: "agTextColumnFilter",
      },
      // {
      //   headerName: "City",
      //   field: "city",
      //   filter: "agTextColumnFilter",
      // },
      {
        headerName: "Channel",
        field: "channel",
        valueGetter: channelGetter,
        filter: "agTextColumnFilter",
      },
      // {
      //   headerName: "Channel Region",
      //   field: "channelRegions",
      //   valueGetter: RegionsGetter,
      //   filter: "agTextColumnFilter",
      // },
      {
        headerName: "Account Manager Email",
        field: "managerEmail",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Comments",
        field: "comments",
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Date Requested",
        field: "requestedDate",
        wrapText: true,
        autoHeight: true,
        valueFormatter: (params) => moment(params.value).format("MMM Do YYYY"),
      },
      {
        headerName: "Action",
        field: "",
        cellRenderer: "actionsCell",
        cellClass: "user__action",
        minWidth: 150,
        cellRendererParams: {
          setDeActivateDialog: setDeActivateDialog,
          setReActivateDialog: setReActivateDialog,
          setUserDeactivateData: setUserDeactivateData,
        },
      },
    ],
  };

  // const getRowStyle = function(props) {
  //   if (props.data.status === "Denied"){
  //     return { color: "#A22B2F !important" }
  //   }
  // }

  // const autoSizeAll = (skipHeader) => {
  //   // gridApi.setHeaderHeight(headerHeight);
  //   // const tableHeight = 2 * headerHeight + rowData.length * rowHeight;
  //   // const maxheight = window.innerHeight - 80;
  //   // if (maxheight > tableHeight) {
  //   //   // gridApi.setDomLayout('autoHeight')
  //   //   // gridApi.setP
  //   // }
  //   // var allColumnIds = [];
  //   // gridColumnApi.getAllColumns().forEach(function (column) {
  //   //   allColumnIds.push(column.colId);
  //   // });
  //   // gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
  //   // gridApi.sizeColumnsToFit()
  // };

  const onGridReady = (params) => {
    params.api.showLoadingOverlay();
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
    // gridApi.setHeaderHeight(params.api.getSizesForCurrentTheme().headerHeight)
    // setRowHeight(params.api.getSizesForCurrentTheme().rowHeight);
    // setHeaderHeight(params.api.getSizesForCurrentTheme().headerHeight);
    // autoSizeAll(true)
  };

  // const sizeToFit = () => {
  //   gridApi.sizeColumnsToFit();
  // };

  const exportUsers = () => {
    gridApi.exportDataAsCsv({ fileName: "Users" });
  };
  React.useEffect(() => {
    async.getRegisteredUsers().then((request) => {
      const data = request.data.length > 0 ? request.data : null;
      setRowData(data);
    });
  }, []);
  React.useEffect(() => {
    if (buttonClick) {
      async.getRegisteredUsers().then((request) => {
        const data = request.data.length > 0 ? request.data : null;
        setRowData(data);
      });
    }

    // if (buttonClick){
    //   userAuthentication()
    // }
    // setButtonClick(false)
  }, [buttonClick]);
  let dialogHeader = "";
  if (ShowApprovedDialog) {
    dialogHeader = "Approve";
  } else {
    dialogHeader = "Reject";
  }

  const firstDataRenderedHandler = (event) => event.columnApi.autoSizeAllColumns();

  let sortedReorderdData = useMemo(() => {
    let sortedRowData = rowData && rowData.slice(0).sort((a, b) => a.status.localeCompare(b.status));
    let startIndexOfNewStatus = sortedRowData && sortedRowData.findIndex((val) => val.status?.toLowerCase() === "new");
    let noOfNewStatusToBeRemoved =
      sortedRowData &&
      sortedRowData.findLastIndex((val) => val.status?.toLowerCase() === "new") - startIndexOfNewStatus + 1;
    let newRowData = sortedRowData && sortedRowData.splice(startIndexOfNewStatus, noOfNewStatusToBeRemoved);
    return newRowData && newRowData.concat(sortedRowData);
  }, [rowData]);

  return (
    <div>
      {/* <Navbar /> */}
      <Toast ref={toast} baseZIndex={20000} />
      <div className='users-grid shadow-2 main-box'>
        <div style={{ display: "flex" }}>
          <div style={{ flex: "1" }}></div>
          <Button label='Export' type='button' className='btn3 news-btn' onClick={() => exportUsers()}></Button>
        </div>
        <p className='m-0'>
          <i>Hover over the status to see the description</i>
        </p>
        <div
          className='ag-theme-alpine-dark'
          id='user-list-grid'
          // style={{ height: 'calc(100vh - 80px - 1rem)', width: "100%" }}
          style={{ height: `calc(100vh - 96px - 6rem)`, width: "100%", marginBottom: "1rem" }}
        >
          <AgGridReact
            rowData={sortedReorderdData}
            components={components}
            columnDefs={gridOptions.columnDefs}
            context={{
              regions: regionData.data,
              chanels: channelData.data,
              userSatuses: userStatuses.data
                ? ["Pending Approval", ...userStatuses.data.map(({ status }) => capitalCase(status))]
                : [],
              userStatusesWithDescription: userStatuses.data?.reduce((prev, curr) => {
                prev[curr.status.toLowerCase()] = curr.description;
                return prev;
              }, {}),
            }}
            // domLayout="autoHeight"
            // getRowStyle={getRowStyle}
            defaultColDef={gridOptions.defaultColDef}
            colResizeDefault={"shift"}
            onGridReady={(params) => onGridReady(params)}
            onFilterChanged={(event) => {
              if (event.api.rowModel.rowsToDisplay.length === 0) {
                event.api.showNoRowsOverlay();
              }
              if (event.api.rowModel.rowsToDisplay.length > 0) {
                event.api.hideOverlay();
              }
            }}
            // onFirstDataRendered={() => autoSizeAll(false)}
            // suppressColumnVirtualisation='true'
            pagination={true}
            paginationAutoPageSize={true}
            onFirstDataRendered={firstDataRenderedHandler}
            overlayNoRowsTemplate='<span style="color: #cccccc">No Rows to Show</span>'
            overlayLoadingTemplate='<span class="ag-overlay-loading-center">Please wait..</span>'

            // headerHeight = {headerHeight}
          ></AgGridReact>
          <Dialog
            className='diag1 userList'
            baseZIndex={10001}
            header={dialogHeader}
            visible={ShowApprovedDialog || showDenyDialog}
            style={{ width: "550px" }}
            ref={dialogRef}
            onHide={() => {
              ShowApprovedDialog ? setApprovedDialog(false) : setDenyDialog(false);
              setSendData({
                ...sendData,
                userRejectReason: "",
                userChannelDetails: {
                  ...sendData.userChannelDetails,
                  channelRejectReason: null,
                },
              });
            }}
            focusOnShow={false}
          >
            <form
              className='diag-box'
              id='user-dialog-form'
              onSubmit={(event) => {
                event.preventDefault();
                ShowApprovedDialog ? handleAcceptSubmit() : handleRejectSubmit();
              }}
            >
              <div className='grid'>
                <div className='col-12 mb-0 pl-0 diag-message1'>
                  {ShowApprovedDialog ? "Are you sure you want to approve the channel?" : ""}
                </div>
                {ShowApprovedDialog && regions.length !== 0 ? (
                  <div className='pl-2'>
                    <div className='field-checkbox sm:col-12 mb-0'>
                      <Checkbox
                        onChange={(e) => {
                          setSendData({
                            ...sendData,
                            isUserChannelApproved: !e.checked,
                            userChannelDetails: {
                              ...sendData.userChannelDetails,
                              channelRejectReason: e.checked ? defaultRejectReason : null,
                              userChannelRegionDetails: sendData?.userChannelDetails?.userChannelRegionDetails.map(
                                (item, index) => {
                                  item["rejectReason"] = null;
                                  return item;
                                }
                              ),
                            },
                          });
                          setChecks(sendData.userChannelDetails.userChannelRegionDetails.map((item) => true));
                        }}
                        checked={!sendData.isUserChannelApproved}
                      />
                      <label className='label' htmlFor='city1'>
                        <div className='col-12 mb-2 diag-message1'>Reject the {channel} channel</div>
                      </label>
                    </div>
                    {/* <div className="col-12 mb-2">"Do you want to approve the channels as well?" </div> */}
                    {!sendData.isUserChannelApproved ? (
                      <div className='col-12'>
                        <div className='text-center diag-reason'>Reason for Rejection</div>
                        <div className='col-12'>
                          <InputTextarea
                            required
                            rows={3}
                            cols={30}
                            value={
                              sendData.userChannelDetails.channelRejectReason === null
                                ? ""
                                : sendData.userChannelDetails.channelRejectReason
                            }
                            onChange={(e) => {
                              handleReasonChange(e);
                            }}
                            keyfilter={/[a-zA-Z,@\s().]/}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className='pl-4'>
                        {regions.map((region, index) => (
                          <UserListDialogBody
                            required
                            key={index}
                            channel={channel}
                            region={region}
                            ind={index}
                            data={sendData}
                            updatedata={setSendData}
                            checks={checks}
                            setChecks={setChecks}
                          />
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <div></div>
                )}
                {showDenyDialog ? (
                  <div>
                    <div className='col-12 mb-1 pl-0 diag-message1'>Are you sure you want to reject this user?</div>
                    <div className='col-12 pr-6 pl-0'>
                      <div className='text-center diag-reason'>User Reject Reason</div>
                      <div className='col-12'>
                        <InputTextarea
                          required
                          rows={3}
                          cols={30}
                          value={sendData.userRejectReason}
                          onChange={(event) => {
                            handleChange(event);
                          }}
                          keyfilter={/[a-zA-Z,@\s().]/}
                        />
                      </div>
                    </div>
                    <div className='col-12 pr-6 pl-0'>
                      <div className='text-center diag-reason'>Channel Reject Reason</div>
                      <div className='col-12'>
                        <InputTextarea
                          required
                          rows={3}
                          cols={30}
                          value={sendData.userChannelDetails.channelRejectReason}
                          onChange={(e) => {
                            handleReasonChange(e);
                          }}
                          keyfilter={/[a-zA-Z,@\s().]/}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}
                <div className='col-6 p-0 mt-3'>
                  <Button
                    label='Confirm'
                    className='p-button p-button-sm diag-save-button'
                    type='submit'
                    form='user-dialog-form'
                  />
                </div>
                <div className='col-6 p-0 mt-3'>
                  <Button
                    label='Cancel'
                    className='p-button p-button-sm diag-discard-button'
                    type='button'
                    onClick={() => {
                      ShowApprovedDialog ? setApprovedDialog(false) : setDenyDialog(false);
                      dialogRef.current.getCloseButton().click();
                    }}
                  />
                </div>
              </div>
            </form>
          </Dialog>
          <Dialog
            className='diag1 userList'
            style={{
              minWidth: "400px",
              maxWidth: "500px",
            }}
            baseZIndex={10001}
            header='User Deactivation'
            visible={showDeActiveDialog}
            focusOnShow={false}
            onHide={() => {
              setDeActivateDialog(false);
            }}
            footer={
              <div className='d-flex'>
                <Button
                  label='Deactivate'
                  className='p-button p-button-sm diag-save-button'
                  type='submit'
                  form='user-dialog-form'
                />
                <Button
                  label='No'
                  className='p-button p-button-sm diag-discard-button'
                  type='button'
                  onClick={(e) => {
                    setDeActivateDialog(false);
                  }}
                />
              </div>
            }
          >
            <form
              className='diag-box'
              id='user-dialog-form'
              onSubmit={(event) => {
                event.preventDefault();
                setDeactivateLoader(true);
                gridApi.showLoadingOverlay();
                const comments = event.target["comments"].value;
                let activationData = {
                  userId: userDeActiveData.userId,
                  code: DEACTIVATION_CODE,
                  comments: comments,
                };
                event.target["comments"].value = "";
                async
                  .activationAPI(activationData)
                  .then(() => {
                    toast.current.show({
                      severity: "success",
                      summary: "Success Message",
                      detail: "User Deactivated Successfully",
                      life: 2000,
                    });
                  })
                  .catch(() => {
                    toast.current.show({
                      severity: "error",
                      summary: "Error Message",
                      detail: "Error Deactivating User",
                      life: 2000,
                    });
                  })
                  .finally(() => {
                    setDeActivateDialog(false);
                    async.getRegisteredUsers().then((request) => {
                      const data = request.data.length > 0 ? request.data : null;
                      setRowData(data);
                    });
                    const { email } = userDeActiveData.toLowerCase();
                    const isInternalUser =
                      email.indexOf("cargill.com") !== -1 || email.indexOf("crgl-thirdparty.com") !== -1;
                    if (isInternalUser) {
                      window.open(userDeActiveData.approvalUrl);
                    }
                    setDeactivateLoader(false);
                    gridApi.hideOverlay();
                  });
              }}
            >
              <div className='grid'>
                <div className='col-12 mb-0 pl-0 diag-message1'>
                  {`Are you sure you want to deactivate User?`}
                  <div className='grid mt-3'>
                    <div className='col-3'>First Name : </div>
                    <div className='col-9'>{userDeActiveData?.firstName}</div>

                    <div className='col-3'>Last Name : </div>
                    <div className='col-9'>{userDeActiveData?.lastName}</div>

                    <div className='col-3'>Email : </div>
                    <div className='col-9'>{userDeActiveData?.email}</div>

                    <div className='col-3'>Company : </div>
                    <div className='col-9'>{userDeActiveData?.companyName}</div>

                    <div className='col-3'>Comments : </div>
                    <div className='col-9'>
                      <InputTextarea style={{ marginLeft: 0 }} name='comments' />
                    </div>
                  </div>
                  {deactivateLoader ? (
                    <div
                      style={{
                        position: "absolute",
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                        backgroundColor: "#000",
                        opacity: "0.65",
                        zIndex: 1,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <ProgressSpinner />
                    </div>
                  ) : null}
                </div>
              </div>
            </form>
          </Dialog>
          <Dialog
            className='diag1 userList'
            style={{
              minWidth: "400px",
              maxWidth: "500px",
            }}
            baseZIndex={10001}
            header='User Reactivation'
            visible={showReActiveDialog}
            focusOnShow={false}
            onHide={() => {
              setReActivateDialog(false);
            }}
            footer={
              <div className='d-flex'>
                <Button
                  label='Reactivate'
                  className='p-button p-button-sm diag-save-button'
                  type='submit'
                  form='user-dialog-form'
                />
                <Button
                  label='No'
                  className='p-button p-button-sm diag-discard-button'
                  type='button'
                  onClick={(e) => {
                    setReActivateDialog(false);
                  }}
                />
              </div>
            }
          >
            <form
              className='diag-box'
              id='user-dialog-form'
              onSubmit={(event) => {
                event.preventDefault();
                gridApi.showLoadingOverlay();
                setDeactivateLoader(true);
                const comments = event.target["comments"].value;
                let activationData = {
                  userId: userDeActiveData.userId,
                  code: ACTIVATION_CODE,
                  comments: comments,
                };
                event.target["comments"].value = "";
                async
                  .activationAPI(activationData)
                  .then(() => {
                    toast.current.show({
                      severity: "success",
                      summary: "Success Message",
                      detail: "User Reactivated Successfully",
                      life: 2000,
                    });
                  })
                  .catch(() => {
                    toast.current.show({
                      severity: "error",
                      summary: "Error Message",
                      detail: "Error Reactivating User",
                      life: 2000,
                    });
                  })
                  .finally(() => {
                    setDeactivateLoader(false);
                    setReActivateDialog(false);
                    async.getRegisteredUsers().then((request) => {
                      const data = request.data.length > 0 ? request.data : null;
                      setRowData(data);
                    });
                    const { email } = userDeActiveData.toLowerCase();
                    const isInternalUser =
                      email.indexOf("cargill.com") !== -1 || email.indexOf("crgl-thirdparty.com") !== -1;
                    if (isInternalUser) {
                      window.open(userDeActiveData.approvalUrl);
                    }
                  });
              }}
            >
              <div className='grid'>
                <div className='col-12 mb-0 pl-0 diag-message1'>
                  {`Are you sure you want to reactivate User?`}
                  <div className='grid mt-3'>
                    <div className='col-3'>First Name : </div>
                    <div className='col-9'>{userDeActiveData?.firstName}</div>

                    <div className='col-3'>Last Name : </div>
                    <div className='col-9'>{userDeActiveData?.lastName}</div>

                    <div className='col-3'>Email : </div>
                    <div className='col-9'>{userDeActiveData?.email}</div>

                    <div className='col-3'>Company : </div>
                    <div className='col-9'>{userDeActiveData?.companyName}</div>

                    <div className='col-3'>Comments : </div>
                    <div className='col-9'>
                      <InputTextarea name='comments' style={{ marginLeft: 0 }} />
                    </div>
                  </div>
                  {deactivateLoader ? (
                    <div
                      style={{
                        position: "absolute",
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                        backgroundColor: "#000",
                        opacity: "0.65",
                        zIndex: 1,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <ProgressSpinner />
                    </div>
                  ) : null}
                </div>
              </div>
            </form>
          </Dialog>
        </div>
      </div>
    </div>
  );
}

export default UserList;
